export const PolicyHandleSourceReNew = 'renew-policy';
export const PolicyHandleSourceUpdate = 'update-policy';
export const PolicyHandleSourceSwitchAnnual = 'switch-policy-annual';
export type PolicyHandleSource = 'renew-policy' | 'update-policy' | 'switch-policy-annual';

export enum PolicyTypes {
  MotorInsurance = 'MotorInsurance',
  BusinessInsurance = 'Business Insurnace',
  PurchaseInsurance = 'PurchaseInsurance',
}

export enum PolicyStatus {
  Active = 'Active',
  ExpireSoon = 'Expire soon',
  Paused = 'Paused',
  Cancelled = 'Cancelled',
  Expired = 'Expired',
}
export interface PolicyProps {
  id: number;
  icon?: any;
  paymentPlan?: 'yearly' | 'monthly';
  name: string;
  description?: string;
  type: PolicyTypes;
  expirationDate: string;
  documents?: {
    id: string;
    name: string;
    url: string;
  }[];
  downloadLink: string;
  claimLink: string;
  status: PolicyStatus;
  cancelDate?: string;
  pauseStartDate?: string;
  pauseEndDate?: string;
  pausingHistory?: PolicyPause[];

  products?: {
    id: string;
    name: string;
    price: number;
    coverage: number;
    slug: string;
    currency: string;
    description?: string;
    startDate: string;
    endDate: string;
  }[];
  quote?: Quote;
}

export type Quote = {
  contact: {
    name: string;
    email: string;
    phoneNumber: string;
  };
  business: {
    type: BusinessType;
    name: string;
    number: string;
    address: string;
    address2: string;
    activities: string[];
    turnover: string;
    employees: number;
    postcode: string;
  };
};

export type PolicyPause = {
  startDate: string;
  endDate: string;
};

export enum BusinessType {
  Limited = 'Limited company',
}

export interface BusinessActivityProps {
  name?: string;
  business_segment?: string;
  action?: string;
  customer_journey?: string;
}
